<h2 class="mb-7">Select the company to proceed</h2>
<div class="border rounded mb-6 py-5 px-3 cursor-pointer company-detail" id="company-{{companyIndex}}"
  *ngFor="let company of companiesList; let companyIndex = index" (click)="handleCompanySelection(company)" (keydown.enter)="handleCompanySelection(company)" 
  (keydown.space)="handleCompanySelection(company)">
  {{ company.company_name }}
</div>
